import { Theme, useTheme } from '@mui/material/styles';
import { useCallback } from 'react';

const getThemeColor = (theme: Theme | null | undefined, color: string): string => {
  if (theme && color in theme.palette) {
    const paletteColor = theme.palette[color as keyof Theme['palette']];
    if (paletteColor && typeof paletteColor === 'object') {
      if ('main' in paletteColor) {
        return paletteColor.main;
      }
      if ('500' in paletteColor) {
        return paletteColor[500];
      }
    }
  }
  return color;
};

export const useThemeColor = () => {
  const theme = useTheme<Theme>();
  return useCallback(
    (color: string) => {
      return getThemeColor(theme, color);
    },
    [theme],
  );
};
